(function(){
  function fmtMoney(cents, format){
    if(window.Shopify && typeof Shopify.formatMoney === 'function'){
      try { return Shopify.formatMoney(cents, format); } catch(e){}
    }
    function withDelimiters(number, precision, thousands, decimal){
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if(isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '${{amount}}';
    var match = formatString.match(placeholderRegex);
    var key = match ? match[1] : 'amount';
    var value;
    switch(key){
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      default: value = withDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }

  function optionLabelOf(opt){
    if(opt == null) return '';
    if(typeof opt === 'object') return opt.name != null ? opt.name : '';
    return String(opt);
  }

  var overlay, contentEl, currentProduct, selectedOptions;

  function init(){
    overlay = document.getElementById('sm-quick-view-dialog');
    contentEl = document.getElementById('sm-qv-content');
    if(overlay){
      overlay.addEventListener('click', function(e){
        if(e.target === overlay) close();
      });
      document.addEventListener('keydown', function(e){
        if(e.key === 'Escape') close();
      });
    }
  }

  function close(){
    if(!overlay) return;
    overlay.classList.remove('show');
    document.body.style.overflow = '';
  }

  window.smQuickViewClose = close;

  function exactVariant(product, opts){
    return product.variants.find(function(v){
      return v.options.every(function(opt, idx){ return opt === opts[idx]; });
    });
  }

  function render(product){
    currentProduct = product;
    var variant = product.variants.find(function(v){ return v.available; }) || product.variants[0];
    selectedOptions = variant.options.slice();

    var img = (variant.featured_image && variant.featured_image.src) || (product.images && product.images[0]) || '';
    if(img && img.indexOf('http') !== 0) img = 'https:' + img;

    var optionsHtml = '';
    var hasRealOptions = product.options && product.options.length && !(
      product.options.length === 1 && optionLabelOf(product.options[0]).toLowerCase() === 'title'
    );
    if(hasRealOptions){
      product.options.forEach(function(rawOptName, optIndex){
        var optName = optionLabelOf(rawOptName);
        var values = [];
        product.variants.forEach(function(v){
          var val = v.options[optIndex];
          if(values.indexOf(val) === -1) values.push(val);
        });
        optionsHtml += '<div class="sm-qv-opt-group">';
        optionsHtml += '<div class="sm-qv-opt-label">' + optName + '</div>';
        optionsHtml += '<div class="sm-qv-opt-radios" data-option-index="' + optIndex + '">';
        values.forEach(function(val){
          var testOpts = selectedOptions.slice();
          testOpts[optIndex] = val;
          var match = exactVariant(product, testOpts);
          var checked = val === selectedOptions[optIndex] ? 'checked' : '';
          var disabled = (!match || !match.available) ? 'disabled' : '';
          var radioId = 'sm-qv-opt-' + optIndex + '-' + String(val).replace(/[^a-zA-Z0-9]/g, '');
          optionsHtml += '<input type="radio" id="' + radioId + '" name="sm-qv-option-' + optIndex + '" value="' + String(val).replace(/"/g,'&quot;') + '" ' + checked + ' ' + disabled + '>';
          optionsHtml += '<label for="' + radioId + '" class="sm-qv-opt-swatch">' + val + '</label>';
        });
        optionsHtml += '</div></div>';
      });
    }

    var priceHtml = '<span class="sm-qv-price" id="sm-qv-price">' + fmtMoney(variant.price, window.shopMoneyFormat) + '</span>';
    if(variant.compare_at_price && variant.compare_at_price > variant.price){
      priceHtml += '<span class="sm-qv-compare" id="sm-qv-compare">' + fmtMoney(variant.compare_at_price, window.shopMoneyFormat) + '</span>';
    } else {
      priceHtml += '<span class="sm-qv-compare" id="sm-qv-compare" style="display:none;"></span>';
    }

    var html = ''
      + '<div class="sm-qv-grid">'
      + '<div class="sm-qv-img-wrap"><img id="sm-qv-img" src="' + img + '" alt="' + (product.title || '').replace(/"/g,'&quot;') + '"></div>'
      + '<div class="sm-qv-details">'
      + '<h2 class="sm-qv-title" id="sm-qv-title">' + product.title + '</h2>'
      + '<div class="sm-qv-price-row">' + priceHtml + '</div>'
      + optionsHtml
      + '<div class="sm-qv-qty-row"><div class="sm-qv-qty-box">'
      + '<button type="button" id="sm-qv-qty-minus">\u2212</button>'
      + '<input type="number" id="sm-qv-qty-input" value="1" min="1">'
      + '<button type="button" id="sm-qv-qty-plus">+</button>'
      + '</div></div>'
      + '<div class="sm-qv-actions">'
      + '<button type="button" id="sm-qv-add-btn" class="sm-qv-add-btn"' + (variant.available ? '' : ' disabled') + '>' + (variant.available ? 'Add to Cart' : 'Sold Out') + '</button>'
      + '<div class="sm-qv-added-msg" id="sm-qv-added-msg">Added to cart \u2713</div>'
      + '<a class="sm-qv-view-link" href="' + product.url + '">View full details \u2192</a>'
      + '</div>'
      + '</div>'
      + '</div>';

    contentEl.innerHTML = html;

    contentEl.querySelectorAll('.sm-qv-opt-radios input').forEach(function(radio){
      radio.addEventListener('change', function(){
        var group = radio.closest('.sm-qv-opt-radios');
        var idx = parseInt(group.getAttribute('data-option-index'));
        selectedOptions[idx] = radio.value;
        var v = exactVariant(product, selectedOptions);
        if(v) updateVariantUI(v);
      });
    });

    var qtyInput = document.getElementById('sm-qv-qty-input');
    document.getElementById('sm-qv-qty-minus').addEventListener('click', function(){
      qtyInput.value = Math.max(1, (parseInt(qtyInput.value) || 1) - 1);
    });
    document.getElementById('sm-qv-qty-plus').addEventListener('click', function(){
      qtyInput.value = (parseInt(qtyInput.value) || 1) + 1;
    });

    document.getElementById('sm-qv-add-btn').addEventListener('click', function(){
      addToCart(variant.id, parseInt(qtyInput.value) || 1);
    });
  }

  function updateVariantUI(variant){
    var img = document.getElementById('sm-qv-img');
    if(variant.featured_image && variant.featured_image.src && img){
      var src = variant.featured_image.src;
      if(src.indexOf('http') !== 0) src = 'https:' + src;
      img.src = src;
    }
    var priceEl = document.getElementById('sm-qv-price');
    var compareEl = document.getElementById('sm-qv-compare');
    if(priceEl) priceEl.textContent = fmtMoney(variant.price, window.shopMoneyFormat);
    if(compareEl){
      if(variant.compare_at_price && variant.compare_at_price > variant.price){
        compareEl.style.display = '';
        compareEl.textContent = fmtMoney(variant.compare_at_price, window.shopMoneyFormat);
      } else {
        compareEl.style.display = 'none';
      }
    }
    contentEl.querySelectorAll('.sm-qv-opt-radios').forEach(function(group){
      var idx = parseInt(group.getAttribute('data-option-index'));
      group.querySelectorAll('input').forEach(function(radio){
        var testOpts = selectedOptions.slice();
        testOpts[idx] = radio.value;
        var match = exactVariant(currentProduct, testOpts);
        radio.disabled = !match || !match.available;
      });
    });
    var addBtnFresh = document.getElementById('sm-qv-add-btn');
    var qtyInput = document.getElementById('sm-qv-qty-input');
    if(addBtnFresh){
      addBtnFresh.disabled = !variant.available;
      addBtnFresh.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      addBtnFresh.onclick = function(){ addToCart(variant.id, parseInt(qtyInput.value) || 1); };
    }
  }

  function addToCart(variantId, quantity){
    var addBtn = document.getElementById('sm-qv-add-btn');
    var addedMsg = document.getElementById('sm-qv-added-msg');
    if(addBtn) { addBtn.disabled = true; addBtn.textContent = 'Adding\u2026'; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    })
    .then(function(res){ return res.json().then(function(data){ return { ok: res.ok, data: data }; }); })
    .then(function(result){
      if(!result.ok){
        throw new Error(result.data && result.data.description ? result.data.description : 'Could not add to cart');
      }
      if(addBtn) { addBtn.disabled = false; addBtn.textContent = 'Add to Cart'; }
      if(addedMsg) { addedMsg.classList.add('show'); setTimeout(function(){ addedMsg.classList.remove('show'); }, 2000); }

      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: result.data, data: { source: 'sm-quick-view' } }
      }));

      fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart, data: { source: 'sm-quick-view', itemCount: cart.item_count } }
        }));
      }).catch(function(){});
    })
    .catch(function(err){
      if(addBtn) { addBtn.disabled = false; addBtn.textContent = 'Add to Cart'; }
      alert(err.message || 'Something went wrong. Please try again.');
    });
  }

  window.smQuickViewOpen = function(url){
    if(!overlay) init();
    if(!overlay) return;
    overlay.classList.add('show');
    document.body.style.overflow = 'hidden';
    contentEl.innerHTML = '<div class="sm-qv-loading">Loading\u2026</div>';

    fetch(url + '.js')
      .then(function(res){ return res.json(); })
      .then(function(product){ render(product); })
      .catch(function(){
        contentEl.innerHTML = '<p style="padding:40px;text-align:center;">Could not load product. <a href="' + url + '">View product page</a></p>';
      });
  };

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
